import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7119421b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parent" }
const _hoisted_2 = { class: "navi pt-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notch" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BBadge = _resolveComponent("BBadge")!
  const _component_BNavItem = _resolveComponent("BNavItem")!
  const _component_BNav = _resolveComponent("BNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(),
      _createVNode(_component_BNav, { fill: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_BNavItem, {
            to: { name: 'MessageRooms' },
            "exact-active-class": "active",
            class: "navi-item"
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          メッセージ\n          "),
              (_ctx.unreadMessageCount > 0)
                ? (_openBlock(), _createBlock(_component_BBadge, {
                    key: 0,
                    pill: "",
                    variant: "red",
                    class: "number-badge"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.unreadMessageCount), 1)
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_BNavItem, {
            to: { name: 'Informations' },
            "exact-active-class": "active",
            class: "navi-item"
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          お知らせ\n          "),
              (_ctx.unreadInformationCount > 0)
                ? (_openBlock(), _createBlock(_component_BBadge, {
                    key: 0,
                    pill: "",
                    variant: "red",
                    class: "number-badge"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.unreadInformationCount), 1)
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}